"use client";

import BaseStoreBox from "../shared/base-store-box";
import ChatReachOutBox from "./ChatReachOutBox";
import Drawermenu from "./drawer-menu";
import styles from "./index.module.css";
import StoreHeader from "./store-header";
import StoreSideMenu from "./store-side-menu";

const convetiTemplateClassNames = {
  dropdown: {
    storeHeaderLocation: {
      root: styles.convetiHeaderLocationDropdown,
      button: styles.convetiLocationDropdownButton,
      text: styles.convetiLocationDropdownText,
      list: styles.convetiLocationDropdownList,
      item: styles.convetiLocationDropdownItem,
    },
    storeDrawerLocation: {
      root: styles.convetiDrawerLocationDropdown,
      button: styles.convetiLocationDropdownButton,
      text: styles.convetiLocationDropdownText,
      list: `${styles.convetiLocationDropdownList} ${styles.convetiDrawerLocationDropdownList}`,
      item: styles.convetiLocationDropdownItem,
    },
  },
  pagination: {
    conveti: {
      root: styles.convetiPagination,
      infinite: styles.convetiPaginationInfinite,
      controls: styles.convetiPaginationControls,
      button: styles.convetiPaginationButton,
      activeButton: styles.convetiPaginationActiveButton,
      ellipsis: styles.convetiPaginationEllipsis,
      limit: styles.convetiPaginationLimit,
      limitLabel: styles.convetiPaginationLimitLabel,
      limitSelect: styles.convetiPaginationLimitSelect,
      viewMore: styles.convetiPaginationViewMore,
      status: styles.convetiPaginationStatus,
      endOfList: styles.convetiPaginationEndOfList,
    },
  },
};

function StoreBox(props) {
  return (
    <BaseStoreBox
      {...props}
      styles={styles}
      templateClassNames={convetiTemplateClassNames}
      Drawermenu={Drawermenu}
      StoreSideMenu={StoreSideMenu}
      StoreHeader={StoreHeader}
      ChatReachOutBox={ChatReachOutBox}
      includeCategoryNavigationInHeader
    />
  );
}

export default StoreBox;
